





























































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Commande} from '@/models';

import CrudCommandeFilter from '@/components/Crud/Commande/Filter.vue';
import CrudCommandeEditDialog from '@/components/Crud/Commande/EditDialog.vue';
import CrudCommandeList from '@/components/Crud/Commande/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeCommande, {CommandeFilter} from '@/stores/modules/commande';

@Component({
	components: {
		CrudCommandeFilter,
		CrudCommandeEditDialog,
		CrudCommandeList,
		CrudDeleteDialog,
	}
})
export default class CommandeListView extends Vue {

	@Stored(() => storeCommande) private commandes!: ResultType<Commande>;
	@Stored(() => storeCommande) private filters!: CommandeFilter;

	private imgPath: string = "";

	private editCommande: Commande = null;
	private deletedCommande: Commande = null;
	private storeCommande = storeCommande;

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editCommande = new Commande();
	}

	private refresh(): void {
		storeCommande.dispatch('getCommandes');
	}
}
